export default "__VITE_ASSET__DCq0ehEi__"